var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "slider-wrapper" }, [
    _c("span", { staticClass: "caption ft-xbld" }, [
      _vm._v(_vm._s(_vm.caption)),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { ref: "outer", staticClass: "slider-outer" },
      [
        _c("slider", {
          attrs: {
            handles: [_vm.startAt],
            step: 1,
            tooltips: "",
            range: {
              min: _vm.rangeMin,
              max: _vm.rangeMax,
            },
          },
          on: { update: _vm.sliderUpdate },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }